// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"62":"7128e310bc5d049f","933":"92de2b604a385b5b"}[chunkId] + ".js";
};